import { render, staticRenderFns } from "./ChallengesMobile.vue?vue&type=template&id=3120d2b6&"
import script from "./ChallengesMobile.vue?vue&type=script&lang=js&"
export * from "./ChallengesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports